// extracted by mini-css-extract-plugin
export var errorIcon = "_mf-1";
export var nameLogo = "_mf-0";